// Dummy authentication data
// In production, this would be stored securely and fetched from a backend

export const dummyUsers = {
  admin: {
    role: 'admin',
    pin: '774481', // 6-digit PIN for admin
    name: 'Admin User',
  },
  waiter: [
    // Demo waiters for login
    {
      userId: 'waiter1',
      password: 'waiter1',
      role: 'waiter',
      name: 'Waiter 1',
    },
    {
      userId: 'waiter2',
      password: 'waiter2',
      role: 'waiter',
      name: 'Waiter 2',
    },
    {
      userId: 'waiter3',
      password: 'waiter3',
      role: 'waiter',
      name: 'Waiter 3',
    },
  ],
  counter: [
    {
      userId: 'counter001',
      password: 'counter123',
      role: 'counter',
      name: 'Mike Johnson',
    },
    {
      userId: 'counter002',
      password: 'counter456',
      role: 'counter',
      name: 'Sarah Williams',
    },
  ],
  kitchen: [
    {
      userId: 'kitchen001',
      password: 'kitchen123',
      role: 'kitchen',
      name: 'Kitchen',
    },
    {
      userId: 'kitchen002',
      password: 'kitchen456',
      role: 'kitchen',
      name: 'Kitchen',
    },
  ],
};

// Authentication helper functions
export const authenticateAdmin = (pin) => {
  return pin === dummyUsers.admin.pin;
};

export const authenticateUser = (role, userId, password) => {
  const users = dummyUsers[role];
  if (!users || !Array.isArray(users)) return null;
  
  const user = users.find(
    (u) => u.userId === userId && u.password === password
  );
  
  return user || null;
};

// Get user info after authentication
export const getUserInfo = (role, credentials) => {
  if (role === 'admin') {
    return dummyUsers.admin;
  }
  
  const user = authenticateUser(role, credentials.userId, credentials.password);
  return user;
};

